import { render, staticRenderFns } from "./changeInvoice.vue?vue&type=template&id=2c478328&scoped=true"
import script from "./changeInvoice.vue?vue&type=script&lang=js"
export * from "./changeInvoice.vue?vue&type=script&lang=js"
import style0 from "./changeInvoice.vue?vue&type=style&index=0&id=2c478328&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c478328",
  null
  
)

export default component.exports